module.exports = __webpack_public_path__ + "img/ry1.5733a83a.png";